module.exports = __webpack_public_path__ + "img/help-white.a40c3e80.svg";